import axios from '../service/axios/axios'

export default {
  /**** 问诊管理模块 ********/
  // 获取问诊记录列表
  consultList(data) {
    return axios({
      method: 'post',
      url: 'platform/Microclinic/consultList',
      data,
    })
  },
  // 查看问诊记录详情
  consultItem(data) {
    return axios({
      method: 'post',
      url: 'platform/Microclinic/consultItem',
      data,
    })
  },
  // 查看病情自述
  complainItem(data) {
    return axios({
      method: 'post',
      url: 'platform/Microclinic/complainItem',
      data,
    })
  },
  // 查看问诊单
  inquiryItem(data) {
    return axios({
      method: 'post',
      url: 'platform/Microclinic/inquiryItem',
      data,
    })
  },
  // 获取原始记录列表
  getMsgList(data) {
    return axios({
      method: 'post',
      url: 'platform/Microclinic/getMsgList',
      data,
    })
  },
  /**** 处方管理模块 ********/
  // 获取处方记录列表
  prescriptionList(data) {
    return axios({
      method: 'post',
      url: 'platform/Microclinic/prescriptionList',
      data,
    })
  },
  /**** 订单管理模块 ********/
  // 获取订单记录列表
  getOrderList(data) {
    return axios({
      method: 'post',
      url: 'platform/Microclinic/getOrderList',
      data,
    })
  },
}
